import { render, staticRenderFns } from "./complaint_type.vue?vue&type=template&id=16c19efd&scoped=true&"
import script from "./complaint_type.vue?vue&type=script&lang=js&"
export * from "./complaint_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c19efd",
  null
  
)

export default component.exports